import * as React from 'react'
import classnames from 'classnames'
import Loading from '../icons/membership/Loading'
import { ISubscriptionPlanDTO, IOrgObj } from '../../types/index'
import { Elements, StripeProvider } from 'react-stripe-elements'
import { CardElement, injectStripe } from 'react-stripe-elements'

interface ISubscriptionPaneProps {
  currentPlanId: string
  organization: IOrgObj
  stripeSourceId: string
  plans: ISubscriptionPlanDTO[]
  fetchingPlans: boolean
  processing: boolean
  listSubscriptionPlans: () => void
  onPlanSelect?: (planId: string, stripeSourceId: string) => void
}

interface ISubscriptionPaneState {
  selectedPlan: string
  useNewCustomer: boolean
}

class SubscriptionPane extends React.Component<ISubscriptionPaneProps, ISubscriptionPaneState> {
  constructor(props: ISubscriptionPaneProps) {
    super(props)

    this.state = {
      selectedPlan: '',
      useNewCustomer: true
    }
  }

  public componentDidMount() {
    this.props.listSubscriptionPlans()
  }

  public componentDidUpdate(prevProps: ISubscriptionPaneProps) {
    if (this.props.organization.subscription && !prevProps.organization.subscription) {
      this.setState({
        useNewCustomer: false
      })
    }
    if (this.props.currentPlanId !== prevProps.currentPlanId) {
      this.setState({
        selectedPlan: ''
      })
    }
  }

  public proceedPayment = (stripeToken: string) => {
    if (this.props.onPlanSelect) {
      this.props.onPlanSelect(this.state.selectedPlan, stripeToken)
    }
  }

  public updatePayment = (ev: any) => {
    if (this.props.onPlanSelect) {
      this.props.onPlanSelect(this.state.selectedPlan, '')
    }
  }

  public render() {
    const { currentPlanId, plans, processing, fetchingPlans } = this.props
    const { selectedPlan, useNewCustomer } = this.state

    const paymentSource =
      this.props.organization.subscription && this.props.organization.subscription.stripeCustomer.sources.data[0]

    const key =
      process.env.REACT_APP_ENV === 'production'
        ? process.env.REACT_APP_STRIPE_KEY_PROD || ''
        : process.env.REACT_APP_STRIPE_KEY_TEST || ''

    const selectPlan = (planId: string) => () => {
      this.setState({
        selectedPlan: planId
      })
    }

    const useNewCard = () => {
      this.setState({
        useNewCustomer: true
      })
    }

    let useExistingCard = null
    if (this.props.organization.subscription) {
      useExistingCard = () => {
        this.setState({
          useNewCustomer: false
        })
      }
    }

    let paymentInfoDiv = <div>Please select plan on the left</div>

    if (paymentSource) {
      paymentInfoDiv = (
        <div style={{ width: '300px' }}>
          <div className='rounded mt1 mr1 ml1 p1 border-grey mb2'>
            <div className='flex'>
              <div className='CCNumber'>**** **** **** {paymentSource.last4}</div>
              <div className='flex1'>&nbsp;</div>
              <div className='ml3'>
                {paymentSource.exp_month} / {paymentSource.exp_year}
              </div>
              <div className='flex1'>&nbsp;</div>
            </div>
          </div>
          {selectedPlan && [
            <button key='proceed' className='btn btn-primary bg-green' onClick={this.updatePayment}>
              Proceed
            </button>,
            <button key='use-new-card' className='btn' onClick={useNewCard}>
              Use new card
            </button>
          ]}
        </div>
      )
    } else if (currentPlanId) {
      paymentInfoDiv = <div>Basic Plan Selected/Premium Plan Selected</div>
    }

    if (selectedPlan && useNewCustomer) {
      paymentInfoDiv = (
        <StripeProvider apiKey={key}>
          <Elements>
            <CardWrapper proceed={this.proceedPayment} useExistingCard={useExistingCard} />
          </Elements>
        </StripeProvider>
      )
    }

    return (
      <div className='p3 flex'>
        <div className='flex justify-center w100'>
          {fetchingPlans && <Loading className='col-1 ml1 animation-updating' />}
          {plans.map(plan => {
            return (
              <div
                key={plan.id}
                className={`border mr4 p3 pl4 pr4 ${currentPlanId === plan.id ? 'border-green' : 'border-grey3'}`}
              >
                <h2>
                  ${(plan.cost_per_month / 100).toFixed(2)}
                  <small> / mo</small>
                </h2>
                <h3>{plan.name}</h3>
                <h5 className='mb1'>{plan.description}</h5>
                <h5 className='mt1'>${(plan.cost_per_trip / 100).toFixed(2)} per trip</h5>
                <button
                  className={classnames({
                    btn: true,
                    'btn-primary bg-green': selectedPlan !== plan.id,
                    'border-grey3': selectedPlan === plan.id
                  })}
                  disabled={currentPlanId === plan.id}
                  onClick={selectPlan(plan.id)}
                >
                  {currentPlanId === plan.id ? 'Current Plan' : selectedPlan === plan.id ? 'Selected' : 'Select'}
                  {selectedPlan === plan.id && processing && '...'}
                </button>
              </div>
            )
          })}
        </div>
        <div className='w100 pr4 mr4'>{paymentInfoDiv}</div>
      </div>
    )
  }
}

export default SubscriptionPane

const CardWrapper = injectStripe(({ stripe, proceed, useExistingCard }: any) => {
  const proceedPayment = () => {
    stripe.createToken().then(({ token }: any) => {
      if (token) {
        proceed(token.id)
      }
    })
  }

  return (
    <div>
      <div className='mb2 bwidth1 border-grey3 p1' style={{ width: '300px' }}>
        <CardElement />
      </div>
      <button className='btn btn-primary bg-green' onClick={proceedPayment}>
        Proceed
      </button>
      {useExistingCard && (
        <button className='btn' onClick={useExistingCard}>
          Use existing card
        </button>
      )}
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/components/subscriptions/SubscriptionPane.tsx